module.exports = __webpack_public_path__ + "ac85fcd6a65e3d1fba691f6766c77242.jpg";